module.exports = __webpack_public_path__ + "static/media/always.44b24a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/always.png
// module id = 103
// module chunks = 0